import { chakra } from '@chakra-ui/system';
import type { HTMLChakraProps } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';
import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';

import { useContainerStyles } from './';
import { getClassName } from './className';

export type ContainerHeaderProps = PropsWithChildren<unknown> &
  HTMLChakraProps<'div'>;

export const ContainerHeader = forwardRef<HTMLDivElement, ContainerHeaderProps>(
  ({ children, className, ...props }, ref) => {
    const styles = useContainerStyles();

    return (
      <chakra.div
        ref={ref}
        __css={styles.containerHeader}
        className={cx(getClassName('header'), className)}
        {...props}
      >
        {children}
      </chakra.div>
    );
  },
);
ContainerHeader.displayName = 'ContainerHeader';
